import React from "react";
import {
  Modal,
  ModalBody,
  InputGroup,
  InputGroupText,
  Input,
  Button,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import keys from "configs/constants";
import "./style.css";
import utils, { checkMac } from "utils";

const RegisterNewGateway = ({
  isOpen,
  toggle,
  value,
  onChange,
  siteGuid,
  t,
}) => {
  const validMac = utils.isMACAddressValid(value);

  const isValid = validMac === checkMac.VALID_MAC || !value || value === "";

  let message = "valid";

  switch (validMac) {
    case checkMac.INVALID_LENGTH:
      message = "registerThing.invalidLength";
      break;
    case checkMac.INVALID_CHARS:
      message = "registerThing.invalidChars";
      break;
    case checkMac.INVALID_OUI:
      message = "registerThing.invalidOui";
      break;

    default:
      break;
  }

  return (
    <Modal centered isOpen={isOpen} toggle={toggle} className="register-gateway-modal">
      <ModalBody>
        <div className="mb-2">{t("gatewayTable.enterMacAddress") + ":"}</div>
        <InputGroup>
          <InputGroupText className="bg-gray text-white">
            {keys.ICON_ADD}
          </InputGroupText>
          <Input
            className={`mac-address-input ${
              isValid ? "" : "border border-danger"
            }`}
            placeholder={t("gatewayProperties.macAddress")}
            value={value || ""}
            onChange={onChange}
          />
        </InputGroup>
        <div className={`text-danger mt-2 ${isValid ? "invisible" : ""}`}>
          {t(message)}
        </div>
        <Button
          color="primary"
          className="float-right mt-4"
          onClick={() => {
            toggle();
            window
              .open(
                `${window.location.origin}/tr?duid=${value.toUpperCase()}${
                  siteGuid ? `&siteGuid=${siteGuid}` : ""
                }`,
                "_self"
              )
              .focus();
          }}
          disabled={validMac !== checkMac.VALID_MAC}
        >
          {t("registerThing.registerIt") + "!"}
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default withTranslation("common")(RegisterNewGateway);
